// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2eEka","cell":"ColumnAccessor_cell__6UBEP","firstCellAccent":"ColumnAccessor_firstCellAccent__1VpgB"};